import type { RouteRecordNormalized } from 'vue-router';
import type { VisibilityContext } from '#layers/access/composables/use-entitlement';

/** Whether the route named `name` passes its `isVisible` gate. A route without a gate is visible. */
export function isRouteVisible(routes: readonly RouteRecordNormalized[], name: string, context: VisibilityContext): boolean {
	const record = routes.find((route) => route.name === name);
	return !record?.meta.isVisible || record.meta.isVisible(context);
}
